import AppModule from '@/stores/modules/app';
import { Store } from 'vuex';
import { getModule } from 'vuex-module-decorators';

let offlineTimeout: any = null;

export function setupOnlineStateManagement(store: Store<any>) {
    const appModule = getModule(AppModule, store);
    const isOnline = (): boolean => {
        fetch(window.location.origin).then((response) => { 
            return response.ok; 
        }).catch(() => { 
            return false; 
        });
        return true;
    }
    appModule.setIsOnline(isOnline());
    window.addEventListener('online', () => {
        if (offlineTimeout !== null) {
            clearTimeout(offlineTimeout);
        }
        offlineTimeout = null;
        appModule.setIsOnline(true);
    });
    window.addEventListener('offline', () => {
        offlineTimeout = setTimeout(() => {
            appModule.setIsOnline(false);
        }, 3000);
    });
}
